// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__GPTNG","active":"Pagination_active__S-Btt"};